var render, staticRenderFns
import script from "./ac-data-table.vue?vue&type=script&lang=js"
export * from "./ac-data-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1315fd16')) {
      api.createRecord('1315fd16', component.options)
    } else {
      api.reload('1315fd16', component.options)
    }
    
  }
}
component.options.__file = "src/components/Table/ac-data-table.vue"
export default component.exports